import LeaveActionComponent from '../LeaveActionComponent.vue'

export default [
    {
        // One-click Approve / Decline landing page for the leave-request
        // notification email. No auth — the ?expires/&signature query is a
        // capability token that this page forwards to the API.
        path: '/leave-action/:id/:decision',
        name: 'LeaveAction',
        meta: { layout: 'blank' },
        component: LeaveActionComponent,
    },
]
